var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$currentUser.role != "account"
    ? _c("div", { staticClass: "header-bottom" }, [
        _c(
          "div",
          { staticClass: "header-nav vue-dropdown-menu" },
          [
            _c(
              "v-dropdown",
              [
                _c(
                  "router-link",
                  { attrs: { slot: "activator", to: "/" }, slot: "activator" },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-star" }),
                    _vm._v("Офферы\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dropdown",
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "activator", to: "/advertisers" },
                    slot: "activator"
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-dollar" }),
                    _vm._v("Рекламодатели\n          ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dropdown",
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "activator", to: "/sources" },
                    slot: "activator"
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-rocket" }),
                    _vm._v("Источники\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dropdown",
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "activator", to: "/data" },
                    slot: "activator"
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-database" }),
                    _vm._v("Данные\n            ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dropdown",
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "activator", to: "/exchange-rates" },
                    slot: "activator"
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-money" }),
                    _vm._v("Курсы валют\n          ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dropdown",
              [
                _c(
                  "a",
                  {
                    attrs: { slot: "activator", href: "#" },
                    slot: "activator"
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-briefcase" }),
                    _vm._v("Отчёты\n            ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/offers-report" } }, [
                      _vm._v(
                        "\n                    Отчет по офферам\n                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/users-report" } }, [
                      _vm._v(
                        "\n                    Отчет по медиабайерам\n                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/sources-report" } }, [
                      _vm._v(
                        "\n                    Отчет по источникам\n                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/date-report" } }, [
                      _vm._v(
                        "\n                    Отчет по времени\n                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/custom-report" } }, [
                      _vm._v(
                        "\n                    Настраиваемый отчет\n                "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.$currentUser.role == "admin"
              ? _c(
                  "v-dropdown",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { slot: "activator", to: "/logs" },
                        slot: "activator"
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-history" }),
                        _vm._v("Логи\n            ")
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$currentUser.role == "admin" ||
            _vm.$currentUser.role == "account"
              ? _c(
                  "v-dropdown",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { slot: "activator", to: "/conversions" },
                        slot: "activator"
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-refresh" }),
                        _vm._v("Конверсии\n            ")
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _c("div", { staticClass: "header-bottom" }, [
        _c(
          "div",
          { staticClass: "header-nav vue-dropdown-menu" },
          [
            _c(
              "v-dropdown",
              [
                _c(
                  "a",
                  {
                    attrs: { slot: "activator", href: "#" },
                    slot: "activator"
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-briefcase" }),
                    _vm._v("Отчёты\n                ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/offers-report" } }, [
                      _vm._v(
                        "\n                        Отчет по офферам\n                    "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a6ece90", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a6ece90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/layouts/partials/TheSiteHeaderBottom.vue
// module id = 638
// module chunks = 0